export default "<button class=\"btn-action\" [class.left]=\"left\" [class.disabled]=\"disabled\">\n    {{title}}\n</button>\n"